var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEditBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 33.5 33.5",
    style: {
      enableBackground: "new 0 0 33.5 33.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D9D9D9;filter:url(#Adobe_OpacityMaskFilter);}\n\t.st1{mask:url(#mask0_1751_31727_1_);}\n\t.st2{fill:#484D63;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33.5,
    height: 33.5
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33.5,
    height: 33.5,
    id: "mask0_1751_31727_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_box_1_",
    x: -5.5,
    y: -5,
    className: "st0",
    width: 44,
    height: 44
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "edit_2",
    className: "st2",
    d: "M3.7,29.8h2.6L22,14l-2.6-2.6L3.7,27.2V29.8z M29.9,11.3l-7.8-7.7l2.6-2.6 C25.4,0.4,26.2,0,27.2,0c1,0,1.9,0.4,2.6,1.1l2.6,2.6c0.7,0.7,1.1,1.6,1.1,2.5c0,1-0.3,1.8-1,2.5L29.9,11.3z M27.2,14L7.8,33.5H0 v-7.8L19.4,6.2L27.2,14z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditBig);
export default __webpack_public_path__ + "static/media/icon_edit_big.026d52365cf55e1465889373ffa444ab.svg";
export { ForwardRef as ReactComponent };